var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHumidity = function SvgHumidity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06 3.07A3 3 0 0 0 9.5 4.41a3.06 3.06 0 0 0 2.28-1.32A2.84 2.84 0 0 0 14 4.41v-1C12.93 3.41 12.26 2 12.26 2l-.43-1-.47.91c-.22.41-1 1.48-1.86 1.48A2.34 2.34 0 0 1 7.56 2l-.39-1-.51.9A3.24 3.24 0 0 1 5 3.34V2a2 2 0 0 0-4 0v6.8A3 3 0 0 0 0 11a3 3 0 0 0 6 0 3 3 0 0 0-1-2.23v-.41a3.66 3.66 0 0 0 2.06-1.29A3 3 0 0 0 9.5 8.41a3.06 3.06 0 0 0 2.28-1.32A2.84 2.84 0 0 0 14 8.41v-1C12.93 7.41 12.26 6 12.26 6l-.43-1-.47.91c-.22.41-1 1.48-1.86 1.48A2.34 2.34 0 0 1 7.56 6l-.39-1-.51.9A3.24 3.24 0 0 1 5 7.34v-3a3.66 3.66 0 0 0 2.06-1.27ZM5 11a2 2 0 1 1-3-1.71V2a1 1 0 0 1 2 0v.5H3v.75h1V4.5H3v.75h1V6.5H3v.75h1V8.5H3v.75h1A2 2 0 0 1 5 11Z"
  })));
};

export default SvgHumidity;